<template>
    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isValid('CanAddMonthlyCost')">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-header DayHeading">
                    {{ $t('MonthlyCost.AddMonthlyCost') }}
                </div>
                <div class="card-body">

                    <div class="row ">


                        <div class="form-group has-label col-12 ">
                            <monthlycostitem :monthlyCost="monthly" v-on:input="getupdatedailyExpenseRows" v-bind:key="renderCost"></monthlycostitem>
                        </div>
                       


                    </div>


                </div>
                <div class="card-footer ">
                    <button type="button" class="btn btn-danger  ml-2 float-right" v-on:click="close()">{{ $t('AddMonthlyCost.btnClear') }}</button>
                    <button type="button" class="btn btn-primary  ml-2 float-right" v-on:click="SaveMonthlyCost" v-bind:disabled="monthlyCost.$invalid"><i class="far fa-save"></i>  {{ $t('AddMonthlyCost.btnSave') }}</button>


                </div>
              
            </div>
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>

<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {

        mixins: [clickMixin],
        data: function () {
            return {

                monthlyCostlist: [],
                renderCost: 0,
                monthly:null,
                monthlyCost: {
                    id: '00000000-0000-0000-0000-000000000000',
                    date: '',
                   
                    monthlyCostItems:[]

                }




            }
        },

        methods: {
           
            getupdatedailyExpenseRows: function (monthlyCostItems) {
                
                this.monthlyCost.monthlyCostItems = monthlyCostItems;
            },
            close: function () {
                this.$router.push('/FinancialSetup')
            },
            SaveMonthlyCost: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.$https.post('/Company/SaveMonthlyCost', this.monthlyCost, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data.isSuccess == true) {
                         {

                            root.$swal({
                                title: "Saved!",
                                text: "Your Monthly Cost has been Created!",
                                type: 'success',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 800,
                                timerProgressBar: true,
                            });


                        }
                        
                    }
                    else {
                        root.$swal({
                            title: "Error!",
                            text: "Your Monthly Cost Already Exist!",
                            type: 'error',
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1200,
                            timerProgressBar: true,
                        });
                    }
                });
            },
            EditMonthlyCost: function () {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/MonthlyCostDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        
                        if ( response.data != "" ) {
                            
                            root.monthlyCost = response.data;
                            root.monthly = response.data;
                            root.renderCost++;

                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },
        created: function () {
            this.EditMonthlyCost();

            this.$emit('input', this.$route.name);
        },
        mounted: function () {
        }
    }
</script>